var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutgoingPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.75C0 3.91751 3.91751 0 8.75 0H19.25C24.0825 0 28 3.91751 28 8.75V19.25C28 24.0825 24.0825 28 19.25 28H8.75C3.91751 28 0 24.0825 0 19.25V8.75Z",
    fill: "#F1F5F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1256_6912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 20.6641H20.6637",
    stroke: "#62748E",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2414 17.5985L8.66871 17.332L7.33594 14.6664L8.06896 14.2999C8.25499 14.2061 8.4604 14.1573 8.66871 14.1573C8.87702 14.1573 9.08243 14.2061 9.26846 14.2999L9.38175 14.3665C9.56777 14.4603 9.77318 14.5091 9.9815 14.5091C10.1898 14.5091 10.3952 14.4603 10.5812 14.3665L11.3343 14L9.3351 10.0017L9.93485 9.70182C10.1565 9.59276 10.4042 9.54747 10.6501 9.571C10.8961 9.59454 11.1306 9.68597 11.3276 9.83509L14.0065 11.8343C14.2041 11.9847 14.4399 12.0768 14.6872 12.1004C14.9345 12.1239 15.1834 12.0779 15.4059 11.9675L18.1981 10.5948C18.5549 10.4149 18.9659 10.3745 19.3509 10.4815L19.9973 10.6681C20.1309 10.7052 20.2545 10.7715 20.3592 10.8624C20.4638 10.9532 20.547 11.0663 20.6025 11.1933C20.658 11.3203 20.6845 11.4581 20.6801 11.5966C20.6757 11.7351 20.6405 11.871 20.5771 11.9942L20.3238 12.5006C20.1706 12.8072 19.924 13.0604 19.6108 13.2203L11.0544 17.4652C10.8028 17.5899 10.5183 17.6318 10.2414 17.5852V17.5985Z",
    stroke: "#62748E",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1256_6912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9933,
    height: 15.9933,
    fill: "white",
    transform: "translate(6.00293 6.00342)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingPlane);
export default __webpack_public_path__ + "static/media/outgoing_plane.4ea6a472a17c6f33ce588d4e370eea6e.svg";
export { ForwardRef as ReactComponent };